import { cn } from '@latitude/token-utils';

type CircularProgressTextProps = {
  progressText: string;
};

export const CircularProgressText = ({
  progressText,
}: CircularProgressTextProps) => {
  return (
    <text
      x="50%"
      y="50%"
      dominantBaseline="central"
      textAnchor="middle"
      className={cn([
        'text-sys-size-12',
        'fill-color-comp-circular-progress-on-container',
        'text-sys-weight-medium-500',
        'font-sys-family-default',
      ])}
    >
      {progressText}
    </text>
  );
};
